import { makeQuery } from 'shared/utilities';

type RequestType = {
    items: {
        id: number,
        sort: number
    }[]
}

type ResponseType = {};

export const columnsOrderQuery = async function (request: RequestType) {
    return await makeQuery<ResponseType>('/columns/order', {
        prefix: 'task-tracker',
        json: request
    });
}
